// NewEntry.js
// Component for adding a new client

// Imports
import React from 'react';
import EditableText from '../Common/EditableText';
import PropTypes from 'prop-types';

// Component Class
// Shows an editable text that, when edited, adds a new client
class NewClient extends React.Component {
  // Renders Component
  render() {
    return (
      <EditableText
        value=""
        clearAfterSet
        placeholder="Clique para adicionar um novo cliente"
        rename={this.props.add}
        minWidth="200"
      />
    );
  }
}

// Required Properties
NewClient.propTypes = {
  add: PropTypes.func.isRequired,
}

// Exports
export default NewClient;



// WEBPACK FOOTER //
// ./src/components/ClientView/NewClient.js